import script from "./termsOfUse.vue?vue&type=script&setup=true&lang=js"
export * from "./termsOfUse.vue?vue&type=script&setup=true&lang=js"

import "./termsOfUse.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__